export default {
    checkout: {
      started: 'Commençons',
      extra: 'Choisissez vos extras',
      almost_there: 'Vous y êtes presque !',
      signin_google: 'Connexion avec Google',
      signin_chenosis: 'Connexion avec',
      or: 'OU',
      login: 'Se connecter',
      email: 'Votre email',
      password: 'Votre mot de passe',
      password_confirmation: 'Confirmez votre mot de passe',
      tip_email_verification: 'La vérification par email est obligatoire pour l\'adresse email fournie.',
      welcome: 'Bienvenue de retour',
      login_as: 'Vous êtes connecté en tant que',
      not: 'Pas',
      sign_out: 'Déconnexion',
      sign_up_google: 'Inscription avec Google',
      sign_up_chenosis: 'Inscription avec',
      sign_up: 'S\'inscrire',
      first_name: 'Votre prénom',
      last_name: 'Votre nom de famille',
      email_registered: 'Votre adresse email est déjà enregistrée !',
      pick_another: 'ou choisissez-en une autre.',
      business: 'Êtes-vous une entreprise ?',
      company: 'Le nom de votre entreprise',
      station_name: 'Parlez-nous de votre station.',
      station: 'Nom de la station',
      website: 'URL du site Web (facultatif)',
      choose_extras: 'Choisissez des extras (facultatif)',
      one_time: 'Une fois',
      add_this: 'Ajouter ceci',
      disclaimer_google: '(Avis de non-responsabilité : un compte Google Play est requis, frais uniques de 30 $)',
      included: 'Inclus',
      disclaimer_apple: '(Avis de non-responsabilité : un compte App Store est requis, frais annuels de 100 $)',
      two_month_free: 'Obtenez 2 mois gratuits !',
      annually_discount: 'Payez votre abonnement annuellement et obtenez 12 mois de service pour le prix de 10 !',
      pay_annually: 'Payer annuellement',
      chose_annual_pay: 'Vous avez choisi de payer votre station annuellement.',
      charge_after_trial: ' sera facturé après la fin de votre essai. Si vous préférez payer mensuellement, veuillez cliquer',
      here: 'ici',
      no_charging: '. Ne vous inquiétez pas, vous ne serez débité de rien aujourd\'hui. Annulez ou mettez à niveau / rétrogradez facilement votre plan à tout moment.',
      then_charge: 'ensuite vous serez facturé',
      trial_ends: 'Votre essai de 7 jours se termine à minuit le',
      per: 'par',
      few_mention: 'Juste quelques points à mentionner.',
      policy: 'Les détails sur la façon dont nous utilisons les informations que vous avez fournies se trouvent dans nos conditions générales et notre politique de confidentialité. Veuillez indiquer que vous avez lu les deux documents et acceptez ces termes avant de continuer. Vous devez accepter ces conditions avant d\'utiliser notre service.',
      confirm: 'Je confirme avoir lu et accepté l\'',
      agreement: 'Accord de confidentialité',
      required: 'Ce champ est requis',
      back: 'Retour',
      step: 'Étape',
      next: 'Suivant',
      select_plan: 'Plan sélectionné',
      storage: ' Stockage',
      listeners: ' Auditeurs',
      bandwidth: ' Bande passante',
      users: ' Utilisateurs',
      return: 'Retour aux tarifs et plans',
      your_extras: 'Vos Extras',
      processing: 'Traitement',
      start_trial: 'Commencer l\'essai gratuit',
    },
  };
  